
import { mapActions } from 'vuex'

export default {
  data: () => ({
    snackbar: false,
    loading: false,
    dialog: false,
    tab: 'login',
    type: 'error',
    message: null,
    disabled: false,
    token: null,
    errors: [],
    showCamera: false,
    show: false,
    requiredPassword: process.env.VUE_APP_TEACHER_REQUIRED_PASSWORD === 'true',
    model: {
      mode:         null,
      email:      null,
      password:   null,
      number_cpf: null,
      birth_date: null,
      mobile_phone: null
    },
    messages: {
      login: 'Acesso com login (email)',
      email: 'Informe seu e-mail para receber link de acesso',
      data: 'Informe seu dados para receber o link de acesso no seu email cadastrado',
      phone: 'Informe seu telefone para receber link de acesso no seu email cadastrado',
      photo: 'Envie uma foto para receber o link de acesso no seu email cadastrado',
    },
    selectedItem: -1,
    items: [],
  }),
  created (){
      
  },
  watch: {
      
      
  },
  methods: {
    
    ...mapActions('auth', ['ActionDoLoginTeacher', 'ActionCheckEmailTeacher']),
    
    completeCapture(file){
      let form = new FormData();
      form.append('photo', file);
      this.access(form);
    },

    sendEmail() {
      this.loading = true;
      this.errors = [];
      this.message = '';

      this.ActionCheckEmailTeacher({ email: this.model.email })
        .then(response => {
          if(response.data.is_auth_password) {
            this.requiredPassword = true;
            this.loading = false;
          } else if(response.data.authorize_url) {
            globalThis.location.href = response.data.authorize_url;
          } else if(response.data.magic_link_sent) {
            this.type = 'success';
            this.message = response.data.message || 'Se o usuário existir em nossa base, enviaremos um e-mail de acesso ao Painel Docente.';
            this.snackbar = true;
            this.loading = false;
          }
        })
        .catch(error => {
          this.errors = error.errors || [];
          this.message = error?.message;
          this.type = 'error';
          this.snackbar = true;
          this.loading = false;
        })
    },

    login() {
      this.disabled = true;
      this.loading = true;
      this.errors = [];
      this.message = '';
      this.snackbar = false;

      this.ActionDoLoginTeacher({
        email: this.model.email,
        password: this.model.password,
        mode: 'login'
      }).then((res) => {
        const periodId = this.$route.query.period_id || res?.data?.workTime?.id
        this.$router.push({ name: 'teacher-panel', query: periodId ? { period_id: periodId } : {} });
      })
      .catch((error) => {
        this.message = error.message;
        this.errors = error.errors ? error.errors : [];
        this.type = 'error';
        this.snackbar = true;
      }).finally(() => {
        this.loading = false;
        this.disabled = false;
      });
    },

    access(form = null){

      this.disabled = true;
      this.loading = true;
      this.errors = [];
      this.message = '';
      this.snackbar = false;

      let payload;

      if(form){
        form.append('mode', this.tab);
        payload = form;
      }else{
        this.model.mode = this.tab;
        payload = this.model;
      }

      this.ActionDoLoginTeacher(payload).then((res) => {

            if(this.tab == 'login'){
              const periodId = this.$route.query.period_id || res?.data?.workTime?.id
              this.$router.push({ name: 'teacher-panel', query: periodId ? { period_id: periodId } : {} });

            }else{
              this.type = 'success';
              this.message = res.message;
              this.snackbar = true;
            }

          })
          .catch((error) =>{
              this.message = error.message;
              this.errors = error.errors ? error.errors : [];
              this.type = 'error';
              this.snackbar = true;
          }).finally(() =>{
              this.loading = false;
              this.disabled = false;
          });
    },

  },
}